import { render, staticRenderFns } from "./ReceiveMaterial.vue?vue&type=template&id=ecb54402&lang=pug&"
import script from "./ReceiveMaterial.vue?vue&type=script&lang=ts&"
export * from "./ReceiveMaterial.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiveMaterial.vue?vue&type=style&index=0&id=ecb54402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports